import en from './en';
import ar from './ar';

export const SUPPORTED_LANGUAGES = ['en', 'ar'];
export const FALLBACK_LANGUAGE = 'en';

const dictionaries = {
    en,
    ar,
};

export default dictionaries;
